import dynamic      from "next/dynamic";
import { useState } from "react";

import { useGetDeviceType } from "_common/hooks/global";
import RecommendationList   from "_components/templates/RecommendationList";

import Ads             from "./ads";
import PlayerContainer from "./components/playerContainer";
import useStyles       from "./styles";

const VideoComments = dynamic ( () => import ( "_components/organisms/videoComments" ) );

const component = props => {
	const {
		changeVideoSrc,
		videoItem,
		videoSrc,
		videoType,
		userId,
		playlist,
		setPlaylist,
		toggleCollapse,
		collapse,
		currentTime,
		previousRoute,
		from,
		rightSideRef,
		thumbnail,
		adTagURL
	} = props;

	const { classes } = useStyles ( { collapse }, { name: "pages/videos" } );

	const [ openCommentModal, setOpenCommentModal ] = useState ( false );

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const customClass = {
		title                    : "1.4rem",
		detailsFont              : "1.2rem",
		image                    : "2rem",
		imgContainerWidth        : "50%",
		gap                      : "1rem",
		rowContentContainerWidth : "50%"
	};

	const playerComponent = (
		<PlayerContainer
			adTagURL           = { adTagURL }
			changeVideoSrc     = { changeVideoSrc }
			from               = { from }
			nextVideoItem      = { playlist?.[0] }
			onClickCommentIcon = { setOpenCommentModal }
			previousRoute      = { previousRoute }
			startTime          = { currentTime }
			thumbnail          = { thumbnail }
			toggleCollapse     = { () => {
				toggleCollapse ( { openOnly: true } );
			} }
			userId             = { userId }
			videoItem          = { videoItem }
			videoSrc           = { videoSrc }
			videoType          = { videoType }
		/>
	);

	const recommendedVideos = (
		<RecommendationList
			currentVideoId = { videoItem.id }
			customClass    = { customClass }
			from           = { "videos" }
			playlist       = { playlist }
			setPlaylist    = { setPlaylist }
			userId         = { userId }
		/>
	);

	if ( isMobileOrTablet ) {
		return (
			<div className = { classes.videosPageContainer }>

				<div className = { classes.playerBodyContainer }>

					{playerComponent}

					{recommendedVideos}

					<VideoComments
						commentCount = { videoItem.commentCount }
						isOpen       = { openCommentModal }
						videoId      = { videoItem?.id }
					/>
				</div>
			</div>
		);
	}

	return (
		<div className = { classes.videosPageContainer }>
			<div className = { classes.playerBodyContainer }>
				{playerComponent}
			</div>

			<div ref   = { rightSideRef }
				className = { classes.rightSideBarContainer }
			>

				<Ads />

				{
					videoItem && (
						<VideoComments
							collapse       = { collapse }
							commentCount   = { videoItem.commentCount }
							toggleCollapse = { toggleCollapse }
							videoId        = { videoItem?.id }
						/>
					)
				}

				{recommendedVideos}

			</div>
		</div>
	);
};

export default component;
